import { createAsyncThunk } from "@reduxjs/toolkit";

import { alertActions } from "../alert/alertSlice";

import {
    getClubhouseTeams,
    getLeague as getLeagueFromAPI,
} from "../../lib/api";
import { IAPIResponse, ILeague, ITeam, IUser } from "../../types/api";

interface IGetTeamsResponse extends IAPIResponse {
    teams: ITeam[];
}

interface IGetLeagueResponse extends IAPIResponse {
    league: ILeague;
}
export const getTeams = createAsyncThunk<
    IGetTeamsResponse,
    { userId: IUser["id"]; isRegistering?: boolean },
    { rejectValue: string }
>(
    "clubhouse/getTeams",
    async (
        { userId, isRegistering = false },
        { rejectWithValue, dispatch },
    ) => {
        try {
            const response = await getClubhouseTeams(userId, isRegistering);

            return response;
        } catch (e) {
            const error = e as string;
            // dispatch(
            //     alertActions.error({
            //         level: "danger",
            //         text: "Team retrieval failed. Please try again later or contact an admin",
            //         title: error,
            //     }),
            // );
            return rejectWithValue(error);
        }
    },
);

export const getLeague = createAsyncThunk<
    IGetLeagueResponse,
    ILeague["id"],
    { rejectValue: string }
>("clubhouse/getLeague", async (leagueId, { rejectWithValue, dispatch }) => {
    try {
        const response = await getLeagueFromAPI(leagueId);

        return response;
    } catch (e) {
        const error = e as string;
        // dispatch(
        //     alertActions.error({
        //         level: "danger",
        //         text: "League retrieval failed. Please try again later or contact an admin",
        //         title: error,
        //     }),
        // );
        return rejectWithValue(error);
    }
});
